var r=Symbol();function e(){var e,n,o=new Promise(function(r,o){e=r,n=o});return o.resolve=e,o.reject=n,o[r]=1,o}function n(e){return!!e&&!!e[r]}export{e as deferred,n as isDeferred};
//# sourceMappingURL=index.mjs.map
